import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { DaysOfMonthConstants } from '../../../../../common/days-of-month.constants';
import { MatChipsModule } from '@angular/material/chips';
import { SchedulerOptionsComponent } from '../scheduler-options-component';
import { ContinuationMode, DayOfWeek, Frequency, Month, MonthlyCalculationMode, MonthlySchedulerDefinition, SchedulerDefinition } from '../../../../api/scheduler-service';
import { MonthlyCalculationModeDisplayMap } from '../../../../model/schedule/monthly-mode-display';


@Component({
  selector: 'monthly-schedule-options',
  imports: [CommonModule, MatSelectModule, MatOption, MatLabel, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatInputModule, MatChipsModule, MatSlideToggleModule],
  templateUrl: './monthly-schedule-options.component.html',
  styleUrl: './monthly-schedule-options.component.css'
})
export class MonthlyScheduleOptionsComponent implements OnInit, SchedulerOptionsComponent {
  @Input() valueChange : Function | undefined;
  
  months = Object.values(Month);
  weekdays = Object.values(DayOfWeek);
  daysOfMonth = DaysOfMonthConstants.daysOfMonth;

  modes = Object.values(MonthlyCalculationMode);
  modesDisplayMap = MonthlyCalculationModeDisplayMap;
  continuationModes = Object.values(ContinuationMode);


  interval : FormControl = new FormControl(1, Validators.min(1));
  monthlyOptionDayMode: FormControl = new FormControl(MonthlyCalculationMode.OnSelectedDay);
  monthlyOptionsSelectedMonth : FormControl = new FormControl([]);
  continuationMode: FormControl = new FormControl(ContinuationMode.Strict);

  monthlyOptionsSelectedDaysOfMonth : FormControl = new FormControl(this.daysOfMonth[0]);
  montlyOptionSelectedDayOfTheWeek: FormControl = new FormControl(DayOfWeek.Monday, []);
  specificDay : FormControl = new FormControl([1, [Validators.min(1), Validators.max(31)]]);
  dependency: FormControl = new FormControl(false);
  
  monthlyOptionsForm: FormGroup = new FormGroup({
    "dependency" : this.dependency,
    "interval" : this.interval,
    "dayMode" : this.monthlyOptionDayMode,
    "specificDay" : this.specificDay,
    "specificDays" : this.monthlyOptionsSelectedDaysOfMonth,
    "selectedMonths" : this.monthlyOptionsSelectedMonth,
    "selectedDayOfTheWeek" : this.montlyOptionSelectedDayOfTheWeek,
    "continuationMode" : this.continuationMode
  });

  lastSelectedDayOfWeek : string = this.weekdays[0];

  constructor() {

  }

  ngOnInit(): void {
    this.monthlyOptionsSelectedMonth.valueChanges.subscribe((v) => this.interval?.setValue(1, {emitEvent: false}));
    this.interval?.valueChanges.subscribe((v) => this.monthlyOptionsSelectedMonth.setValue([], {emitEvent: false}));

    this.montlyOptionSelectedDayOfTheWeek.valueChanges.subscribe(val => {
      if (val == null) {
        // If user attempts to deselect the only chip, revert to last valid selection.
        this.montlyOptionSelectedDayOfTheWeek.setValue(this.lastSelectedDayOfWeek, { emitEvent: false });
      } else {
        this.lastSelectedDayOfWeek = val;
      }
    });

    setTimeout(() => this.monthlyOptionsForm.valueChanges.subscribe(() => {
      if (this.valueChange != undefined) {
        this.valueChange();
      }
    }), 0);
  }
  
  isMonthlyOnSpecificDays() : boolean {
    return this.monthlyOptionDayMode.value === MonthlyCalculationMode.OnSelectedDay;
  }

  isMonthlyOnSelectedDayOfWeek() : boolean {
    return this.isMonthlyOnFirstDayOfWeek() || 
          this.isMonthlyOnSecondDayOfWeek() ||  
          this.isMonthlyOnThridDayOfWeek() ||  
          this.isMonthlyOnFourthDayOfWeek() ||  
          this.isMonthlyOnLastDayOfWeek();
  }


  isMonthlyOnFirstDayOfWeek() : boolean {
    return this.monthlyOptionDayMode.value === MonthlyCalculationMode.OnFirstSelectedWeekdayOfMonth;
  }
  
  isMonthlyOnLastDayOfWeek() : boolean {
    return this.monthlyOptionDayMode.value === MonthlyCalculationMode.OnLastSelectedWeekdayOfMonth;
  }

  isMonthlyOnSecondDayOfWeek() : boolean {
    return this.monthlyOptionDayMode.value === MonthlyCalculationMode.OnSecondSelectedWeekdayOfMonth;
  }

  isMonthlyOnThridDayOfWeek() : boolean {
    return this.monthlyOptionDayMode.value === MonthlyCalculationMode.OnThirdSelectedWeekdayOfMonth;
  }

  isMonthlyOnFourthDayOfWeek() : boolean {
    return this.monthlyOptionDayMode.value === MonthlyCalculationMode.OnFourthSelectedWeekdayOfMonth;
  }

  getSchedulerDefinition() : SchedulerDefinition {
    const scheduleDefinition: MonthlySchedulerDefinition = {
      frequency: Frequency.Monthly,
      eventDependency: this.dependency.value,
      interval: this.interval.value,
      months: this.monthlyOptionsSelectedMonth.value,
      mode: this.monthlyOptionDayMode.value,
      continuationMode: this.continuationMode.value,
      selectedDayOfMonth: this.daysOfMonth.indexOf(this.monthlyOptionsSelectedDaysOfMonth.value) + 1,
      selectedDayOfWeek: this.montlyOptionSelectedDayOfTheWeek.value,
    };
    return scheduleDefinition;
  }

  getIntervalSuffix() : string {
    return (this.interval.value > 1) ? "months" : "month";
  }

  intervalHasError() : boolean {
    return !this.interval.valid;
  }

  intervalErrorMessage() : string {
    if (this.interval.hasError("min")) {
      return "Interval must be 1 or higher";
    }

    return "";
  }


}
